import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { colorClasses } from '../menu/DivisionsDropdown';

export default function TagRender({ tagMap, tagIds, useRedesign, labelKey = 'name' }) {
  const tagIdColorMap = useMemo(() => (
    Object.fromEntries(
      Object.values(tagMap)
        .map((tag, index) => [tag.id, colorClasses[index % colorClasses.length]]),
    )
  ), [tagMap]);

  if (!useRedesign) {
    return tagIds.map((tagId) => tagMap[tagId]?.[labelKey]).filter((tagName) => !!tagName).join(', ');
  }

  return (
    <div className="division-blocks-container">
      {tagIds.map((tagId) => (
        <div key={tagId} className={`division-block division-block-base ${tagIdColorMap[tagId]}`}>
          <span className="division-text division-label">
            {tagMap[tagId]?.[labelKey] ?? ''}
          </span>
        </div>
      ))}
    </div>
  );
}

TagRender.propTypes = {
  tagMap: PropTypes.objectOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
  })),
  tagIds: PropTypes.arrayOf(PropTypes.string),
  useRedesign: PropTypes.bool,
  labelKey: PropTypes.string,
};

TagRender.defaultProps = {
  tagMap: {},
  tagIds: [],
  useRedesign: false,
  labelKey: 'name',
};
